import axios from "axios";
import Globais from "../components/Globais";

export type GerarCobrancaAssinaturaPublicaPayload = {
  pessoaId: number;
  quantidadeCotas: number;
  formaPagamento?: "PIX" | "CARTAO";
  planoAssinatura?: "ANUNCIO_PROPRIEDADE";
};

export type GerarCobrancaAssinaturaPublicaResponse = {
  reutilizada: boolean;
  assinatura?: {
    id: number;
    pessoaId: number;
    usuarioId: number;
    cotasUsuariosId: number | null;
    planoAssinatura: string;
    status: string;
  };
  pagamento?: {
    id: number;
    origemTipo: string;
    origemId: number;
    tipo: string;
    status: string;
    valor: number;
    linkPagamento: string;
    gatewayPaymentId: string;
  };
};

export const gerarCobrancaAssinaturaPublicaService = async (
  payload: GerarCobrancaAssinaturaPublicaPayload
) => {
  const url = `${Globais.DOMINIOBACK}/assinatura/publica/gerar-cobranca`;
  const response = await axios.post<GerarCobrancaAssinaturaPublicaResponse>(
    url,
    payload
  );

  return response.data;
};
